import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { TrendingSearchEntity } from '../../domain/entities/TrendingSearchEntity'

export class TrendingSearchModel extends TrendingSearchEntity {
  constructor(dataDto: TrendingSearchEntity) {
    super()
    mapEntityProperties<TrendingSearchModel>(this, dataDto, {
      map: {
        channel: {
          id: dataDto.channelId,
          name: dataDto.channelName
        }
      }
    })
  }
}
